<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            المتابعة وإعداد التقارير المالية
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            جودة نظم المتابعة المالية ومستوى الشفافية
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-finance')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">2/9</div>
          <div class="kpi-label">لديها نظام محاسبة رسمي</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">4/9</div>
          <div class="kpi-label">تقارير مالية دورية</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card success">
          <div class="kpi-value">3/9</div>
          <div class="kpi-label">تخضع لتدقيق خارجي</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">6/9</div>
          <div class="kpi-label">لا شفافية في الموازنة</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">جودة المتابعة والتقارير المالية</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>نظام المحاسبة</th>
            <th>تقارير شهرية؟</th>
            <th>تقرير سنوي؟</th>
            <th>تدقيق خارجي؟</th>
            <th>لوحة متابعة؟</th>
            <th>درجة الشفافية/100</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>{{ item.accountingSystem }}</td>
            <td>
              <v-chip
                :color="statusColor(item.monthlyReport)"
                size="small"
                variant="flat"
                >{{ item.monthlyReport }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="statusColor(item.annualReport)"
                size="small"
                variant="flat"
                >{{ item.annualReport }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="statusColor(item.externalAudit)"
                size="small"
                variant="flat"
                >{{ item.externalAudit }}</v-chip
              >
            </td>
            <td>{{ item.dashboard }}</td>
            <td
              class="font-weight-bold"
              :class="transparencyClass(item.transparencyScore)"
            >
              {{ item.transparencyScore }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    accountingSystem: "يدوي",
    monthlyReport: "جزئي",
    annualReport: "نعم",
    externalAudit: "لا",
    dashboard: "لا",
    transparencyScore: 40,
  },
  {
    name: "مستشفى الأمراض النفسية",
    accountingSystem: "يدوي",
    monthlyReport: "لا",
    annualReport: "لا",
    externalAudit: "لا",
    dashboard: "لا",
    transparencyScore: 20,
  },
  {
    name: "مجمع الشيخ عثمان",
    accountingSystem: "Excel",
    monthlyReport: "نعم",
    annualReport: "نعم",
    externalAudit: "جزئي",
    dashboard: "لا",
    transparencyScore: 55,
  },
  {
    name: "مركز كود العثماني",
    accountingSystem: "Excel",
    monthlyReport: "نعم",
    annualReport: "نعم",
    externalAudit: "لا",
    dashboard: "لا",
    transparencyScore: 60,
  },
  {
    name: "مركز الممدارة",
    accountingSystem: "HMIS",
    monthlyReport: "نعم",
    annualReport: "نعم",
    externalAudit: "نعم",
    dashboard: "جزئي",
    transparencyScore: 75,
  },
  {
    name: "مركز المحاريق",
    accountingSystem: "يدوي",
    monthlyReport: "لا",
    annualReport: "لا",
    externalAudit: "لا",
    dashboard: "لا",
    transparencyScore: 25,
  },
  {
    name: "مركز عبد القوي",
    accountingSystem: "Excel",
    monthlyReport: "نعم",
    annualReport: "نعم",
    externalAudit: "لا",
    dashboard: "لا",
    transparencyScore: 65,
  },
  {
    name: "مركز ماري ستبوس",
    accountingSystem: "يدوي",
    monthlyReport: "لا",
    annualReport: "لا",
    externalAudit: "نعم",
    dashboard: "لا",
    transparencyScore: 30,
  },
  {
    name: "جمعية حقوق الطفل",
    accountingSystem: "Excel",
    monthlyReport: "نعم",
    annualReport: "نعم",
    externalAudit: "نعم",
    dashboard: "لا",
    transparencyScore: 70,
  },
];

const statusColor = (value) => {
  if (value === "نعم") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const transparencyClass = (value) => {
  if (value >= 70) return "text-green-darken-2";
  if (value >= 40) return "text-orange-darken-2";
  return "text-red-darken-2";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.success {
  background: #e8f5ee;
  color: #1a7a4a;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
